'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

var _createColorPalette = require('./createColorPalette'),
    _createColorPalette2 = _interopRequireDefault(_createColorPalette);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var cheddar = {
  1: '#fef3e9',
  2: '#fec491',
  3: '#fead64',
  4: '#f58525',
  5: '#e06107',
  6: '#ca500f',
  7: '#b0430c',
  8: '#983600',
  9: '#772700',
  10: '#571d00',
  inflection: 6
};
exports.default = (0, _createColorPalette2.default)(cheddar, 'cheddar');